module.exports = __webpack_public_path__ + "img/device-icon.04929590.svg";